import { getCurrentUserToken, getHasRememberedBetterAuthSessionUser } from '../auth/authService';
import { clearLocalUserSessionState } from '../auth/authLogoutActions';
import { clearCachedReduxState } from '../offline/cache/localCache';
import { selectHasAuthenticatedCurrentUser } from './currentUserSelector';

type FetchMeConfig = {
    withCredentials: true;
    skipAuthHeader: true;
};

type BetterAuthSessionDetails = {
    hasLegacyToken: boolean;
    hasRememberedBetterAuthSessionUser: boolean;
    hasHydratedCurrentUser: boolean;
};

export const getHasBetterAuthSession = ({
    hasLegacyToken,
    hasRememberedBetterAuthSessionUser,
    hasHydratedCurrentUser,
}: BetterAuthSessionDetails): boolean =>
    !hasLegacyToken && (hasRememberedBetterAuthSessionUser || hasHydratedCurrentUser);

export const getCurrentUserAuthSessionState = (
    state: unknown,
): {
    hasLegacyToken: boolean;
    hasBetterAuthSession: boolean;
} => {
    const hasLegacyToken = !!getCurrentUserToken();
    const hasRememberedBetterAuthSessionUser = getHasRememberedBetterAuthSessionUser();
    const hasHydratedCurrentUser = selectHasAuthenticatedCurrentUser(state);

    return {
        hasLegacyToken,
        hasBetterAuthSession: getHasBetterAuthSession({
            hasLegacyToken,
            hasRememberedBetterAuthSessionUser,
            hasHydratedCurrentUser,
        }),
    };
};

export const getFetchMeConfig = (hasBetterAuthSession: boolean): FetchMeConfig | undefined => {
    if (!hasBetterAuthSession) return undefined;

    return {
        withCredentials: true,
        skipAuthHeader: true,
    };
};

export const clearInvalidBetterAuthSession = async (): Promise<void> => {
    // Reuse the same cleanup as an explicit logout so a lapsed session leaves the browser in an
    // identical state; the forced-logout path keeps its own boot-appropriate guest transition.
    clearLocalUserSessionState();
    await clearCachedReduxState();
};
